/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerSalesContractDescription = {

  async getDescriptionByRecordId(recordId) {
    var requestScreenData = {
      url: "api/CustomerSalesContractLineDescription",
      filter: `RecordId eq ${recordId}`,
      select: "RecordId,Description",
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getAllDescriptionsAndRecordIds() {
    var requestScreenData = {
      url: "api/CustomerSalesContractLineDescription",
      select: "RecordId,Description,Inactive",
      filter: "Inactive eq 'N'"
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerSalesContractDescription };
